const hasAddresses = (addresses) => {
  const format = address => `${address.address}, ${address.city}, ${address.state} ${address.zipCode}`;
  return {
    getDefaultAddress() {
      const index = addresses.findIndex(address => address.isDefault);
      return format(addresses[index]);
    },
    getFormattedAddresses() {
      return addresses.map((address) => {
        const formatted = {
          label: address.label,
          address: format(address),
        };
        if (address.isDefault) {
          formatted.isDefault = true;
        }
        return formatted;
      });
    },
  };
};

export default hasAddresses;
